import { Component, Input } from '@angular/core';
import { ReviewCardComponent } from '../review-card/review-card.component';
import { ReviewCheckedItem } from '../models/review-checkedItem';
import { ReviewService } from '../review.service';
import { ReviewFilter } from '../models/review-filter';
import { ReviewFilterItem } from '../models/review-filter-item';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'sepidz-static-select-review',
  templateUrl: './static-select-review.component.html',
  styleUrls: ['./static-select-review.component.scss']
})
export class StaticSelectReviewComponent extends ReviewCardComponent {
  @Input()
  items: ReviewCheckedItem[] = [];
  @Input() valueType: 'array' | 'boolean' | 'booleanList' | 'joinedString' | 'text' | 'number';
  @Input() form: UntypedFormGroup;
  @Input() apiName: string;
  @Input() systemName: string;
  @Input() category: string;
  @Input() textFieldName: string = "Title";
  @Input() valueFieldName: string = "Id";
  @Input() hasItemValue: boolean = false;

  constructor(service: ReviewService) {
    super(service);
  }

  protected prepareFilterForLoading(filter: ReviewFilter) {
    const filterForLoad = { ...filter };
    filterForLoad.items = filter.items;
    return filterForLoad;
  }

  protected filterChanging(filter: ReviewFilter): void {
    this.items.forEach(item => {
      item.checked = filter.items.some(
        filterItem =>
          filterItem.key === this.key && (this.valueType === 'number' || this.valueType === 'text' || filterItem.value === item.Value)
      );
      if (!item.checked) {
        if (this.valueType === 'boolean' && this.form.controls[this.key].value)
          this.form.controls[this.key].setValue(item.checked);
        //if (this.valueType === 'booleanList' && this.form.controls[this.key].value)
        //  this.form.controls[this.key].setValue(item.checked);
        if ((this.valueType === 'number' || this.valueType === 'text') && this.form.controls[this.key].value)
          this.form.controls[this.key].setValue(item.Value);
      }
    });
  }

  changed(value: any, item: any) {
    if (this.valueType === 'booleanList') {
      if (value) {
        this.service.addFilter(this.name, [
          <ReviewFilterItem>{
            key: this.key,
            value: value.Id,
            title: value.Title,
            persianKey: this.title,
            valueType: this.valueType,
            checked:false
          }
        ]);
      }
    }

    if (this.valueType === 'boolean') {
      item.checked = value.checked;
      if (value) {
        this.service.addFilter(this.name, [
          <ReviewFilterItem>{
            key: this.key,
            value: value,
            title: item.Name,
            persianKey: this.title,
            checked: false,
            valueType: this.valueType
          }
        ]);
        item.Value = value;
      } else {
        this.service.removeFilter(this.name, this.key, [item.Value], this.valueType);
      }
    }
    if (this.valueType === 'text' || this.valueType === 'number' || this.valueType === 'array') {
      if (value) {
        item.Value = this.valueType === 'array' ? value[this.valueFieldName] : value;
        this.service.addFilter(this.name, [
          <ReviewFilterItem>{
            key: this.key,
            value: this.valueType === 'array' ? value[this.valueFieldName] : value,
            title: item.Name,
            persianKey: this.title,
            checked: false,
            valueType: this.valueType === 'array' ? 'number' : this.valueType
          }
        ]);
      }
      else {
        this.service.removeFilter(this.name, this.key, [item.Value], this.valueType);
      }
    }
  }

  protected loadItems(filter: ReviewFilter): void {
    this.items.forEach(item => {
      item.checked = filter.items.some(
        filterItem =>
          filterItem.key === this.key && filterItem.value === item.Value
      );
    });
  }

  trackByValue(index, item) {
    return item.Value;
  }
}
